import { useCallback } from "react"

export function useLocalizer(lang) {
  const suffix = !lang || lang === "it" ? "" : "_en"
  const templateFn = useCallback((template) => template + suffix, [suffix])

  return templateFn
}
